import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
var api__postUserWorkInfo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var work_sector, employer_name, salary, salary_transfer_method, traffic_fine, traffic_fine_value, other_financial_liabilities, total_financial_liabilities, order_uuid, params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          work_sector = _ref.work_sector, employer_name = _ref.employer_name, salary = _ref.salary, salary_transfer_method = _ref.salary_transfer_method, traffic_fine = _ref.traffic_fine, traffic_fine_value = _ref.traffic_fine_value, other_financial_liabilities = _ref.other_financial_liabilities, total_financial_liabilities = _ref.total_financial_liabilities, order_uuid = _ref.order_uuid;
          params = {
            work_sector: work_sector,
            employer_name: employer_name,
            salary: salary,
            salary_transfer_method: salary_transfer_method,
            traffic_fine: traffic_fine,
            traffic_fine_value: traffic_fine_value,
            other_financial_liabilities: other_financial_liabilities,
            total_financial_liabilities: total_financial_liabilities,
            order_uuid: order_uuid
          };
          _context.n = 1;
          return fetcher(null, true).post('finance/job-form', params);
        case 1:
          res = _context.v;
          return _context.a(2, res || null);
      }
    }, _callee);
  }));
  return function api__postUserWorkInfo(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default api__postUserWorkInfo;